import React from 'react'

const FileUploadBox = ({ label, files, children, ...props }) => (
  <div>
    <div className="field">
      <div className="file is-primary">
        <label className="file-label">
          <input className="file-input" type="file" {...props} />
          <span className="file-cta">
            <span className="file-icon">
              <i className="fas fa-upload" />
            </span>
            <span className="file-label">{label}</span>
          </span>
        </label>
      </div>
    </div>
    {children}
  </div>
)

export default FileUploadBox



// WEBPACK FOOTER //
// ./src/modules/images-upload/FileUploadBox.js